import React, { useState, useEffect } from 'react';
import { RomAssessmentPanel } from './RomAssessment';

/* ── Lab Entry Splash (show image for 3 seconds then fade out) ──────────────── */
function LabEntrySplash({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const hold = setTimeout(() => setFading(true), 3000);
    const done = setTimeout(() => onDone(), 3600);
    return () => { clearTimeout(hold); clearTimeout(done); };
  }, [onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#080c1a',
      opacity: fading ? 0 : 1,
      transition: 'opacity 0.6s ease-out',
    }}>
      <div style={{
        width: '90%', height: '90%',
        backgroundImage: 'url(/LabEntry.jpeg)',
        backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
        borderRadius: 12,
      }} />
    </div>
  );
}

export default function LabReadingsView({ patientCard }) {
  const [showSplash, setShowSplash]   = useState(true);

  if (!patientCard) {
    return <div style={{ padding: 24, color: '#888' }}>No patient selected.</div>;
  }

  return (
    <>
    {showSplash && <LabEntrySplash onDone={() => setShowSplash(false)} />}
    <div style={{
      padding: '14px 16px', background: '#eef0f4', minHeight: '80vh',
      opacity: showSplash ? 0 : 1,
      transform: showSplash ? 'scale(0.97)' : 'scale(1)',
      transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
    }}>
      {/* ── Assessment entry ── */}
      <div style={{
        background: '#fff', borderRadius: 12,
        border: '1px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 12px rgba(0,0,0,.09)',
        marginBottom: 18, overflow: 'hidden',
      }}>
        <div style={{ padding: '11px 16px', fontSize: 13, fontWeight: 700, color: '#1a1c2e', borderBottom: '1px solid rgba(0,0,0,.06)' }}>
          🔬 ROM &amp; Muscle Lab Assessment
        </div>
        <RomAssessmentPanel patientCard={patientCard} />
      </div>

    </div>
    </>
  );
}
